var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 29,
    viewBox: "0 0 453 260",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1760,-153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cutted",
    transform: "matrix(0.537428,0,0,0.435154,1760.3,153.941)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 841.89,
    height: 595.276,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.44231,0,0,9.19147,286.214,574.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-ranna"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,-60.875L17.035,-46.581L-36.982,-1.255C-37.554,-0.775 -36.979,0.128 -36.302,-0.187L70.129,-49.817C76.329,-52.708 74.268,-62.003 67.427,-62.003L0.411,-62.003C-0.186,-62.003 -0.457,-61.258 0,-60.875M38.18,-28.838L50.178,-18.771C51.967,-17.269 51.592,-14.417 49.475,-13.43L18.846,0.852C18.254,1.128 17.678,0.442 18.053,-0.093L28.48,-14.985L17.243,-19.075L38.18,-28.838Z",
    style: {
      fill: "rgb(0,172,215)",
      fillRule: "nonzero"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6f93a3ae25a35d53f8d7ac8b7766e753.svg";
export { ForwardRef as ReactComponent };